import React from 'react'
import { Box, Container, Paper, SimpleGrid, Stack, Text } from '@mantine/core'
import SectionHeader from './shared/SectionHeader'
import { BRAND_COLOR, SERVICE_CONTENT, SOURCE_CONTENT } from '../utils/constants'

export default function ServiceIntro() {
  return (
    <Box id="service" py={{ base: 60, md: 100 }} style={{ backgroundColor: '#FFFFFF' }}>
      <Container size="xl">
        <SectionHeader badge={SERVICE_CONTENT.badge} title={SERVICE_CONTENT.title} centered />

        <Stack gap="xl" mt={40}>
          <Paper
            p="xl"
            radius="lg"
            style={{
              backgroundColor: '#F8FAFC',
              border: '1px solid #E5E7EB',
            }}
          >
            <Text size="md" c="#4B5563" style={{ lineHeight: 1.8, textAlign: 'center' }}>
              {SERVICE_CONTENT.subtitle}
            </Text>
            <Text size="sm" c="#6B7280" mt="md" style={{ textAlign: 'center' }}>
              {SERVICE_CONTENT.note}
            </Text>
          </Paper>

          <Box mt="xl">
            <SectionHeader badge={SOURCE_CONTENT.badge} title={SOURCE_CONTENT.title} centered />

            <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg" mt={32}>
              {SOURCE_CONTENT.sources.map((source) => (
                <Paper
                  key={source.title}
                  p="xl"
                  radius="lg"
                  style={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: '12px',
                      backgroundColor: `${BRAND_COLOR}15`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px',
                    }}
                  >
                    <source.icon size={28} color={BRAND_COLOR} />
                  </Box>
                  <Text size="lg" fw={600} c="#1F2329" mb="xs">
                    {source.title}
                  </Text>
                  <Text size="sm" c="#6B7280" style={{ lineHeight: 1.6 }}>
                    {source.description}
                  </Text>
                </Paper>
              ))}
            </SimpleGrid>

            <Box
              mt="xl"
              p="md"
              style={{
                borderRadius: 12,
                backgroundColor: `${BRAND_COLOR}08`,
                border: `1px solid ${BRAND_COLOR}15`,
              }}
            >
              <Text size="sm" c="#4B5563" style={{ textAlign: 'center' }}>
                {SOURCE_CONTENT.note}
              </Text>
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  )
}
